import React, { useEffect, useState,useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { getSearchSuggestions, getTrendingWord } from "../services/SearchService";
import { useSelector } from "react-redux";

const HeaderSearch = ({ className, setIsSearchActive }) => {
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const type = params.get("type");
  const key = params.get("key");

  const history = useHistory();
  const [suggestions, setSuggestion] = useState([]);
  const [value, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [shouldRender, setShouldRender] = useState(2);


  const [trendWords, setTrendWords] = useState([]);
  const [userSearchHistory, setUserSearchHistory] = useState([]);

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const inputRef = useRef(null);

  const onChange = (event, { newValue }) => {
    //console.log(newValue);
    setValue(newValue);
  };
  const onKeyDown = (e) => {
    setShouldRender(3);
    if (e.keyCode === 13) {
      setDropdownVisible(false);
      if (value) {
        history.push(`/search?type=text&key=${value}`);
      }
      else {
        history.push(`/`);
      }
      setIsSearchActive(false);
    }
  };

  

  const getSuggestions = async (value) => {

    const sugRes = await getSearchSuggestions(value);
    setSuggestion(sugRes);
    console.log(sugRes);
    return sugRes;
  };

  useEffect(() => {
    if (value) {
      const inputValue = value.trim().toLowerCase();
      const timeoutId = setTimeout(() => getSuggestions(inputValue), 300);
      return () => clearTimeout(timeoutId);
    } else setSuggestion([]);
  }, [value]);


  const renderSuggestion = (suggestion) => {
    const index = suggestion.toLowerCase().indexOf(value.toLowerCase());
    if (index === -1) return suggestion;

    const beforeMatch = suggestion.slice(0, index);
    const match = suggestion.slice(index, index + value.length);
    const afterMatch = suggestion.slice(index + value.length);

    return (
      <span>
        {beforeMatch}
        <span>{match}</span>
        <b>{afterMatch}</b>
      </span>
    );
  };
  const searchResult = useSelector((state) => state.searchReducer.result);

  useEffect(() => {
    // if (selectedValue.toString() !== key && value !== key) {
    //   setValue("");
    // }
    if (key != null && key != "" && value !== key) {
      setValue(key);
    }
  }, [searchResult]);

  //  -----  V.N : New Version

  useEffect(() => {
    const fetchTrendingWords = async () => {
      try {
        const res = await getTrendingWord();

        console.log('TrendingWords :');
        console.log(res.trending);
        setTrendWords(res.trending || []);
        setUserSearchHistory(res.usersearch || []);
      } catch (error) {
        console.error("Error fetching trending words:", error);
      }
    };

    fetchTrendingWords();
  }, []);
  const inputsearchProps = {
    placeholder: "Search for products..",
    value,
    type: "text",
    className: "search-input",
    onChange: (e) => setValue(e.target.value),
    onKeyDown: onKeyDown,
  };
  const onInputClick = () => {
    setDropdownVisible(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0); 
  };

  const renderDropdown = () => {
    if (!dropdownVisible) return null;

    return (
      <>
        <div
          className="overlay"
          onClick={() => setDropdownVisible(false)}
        ></div>
        <div  className={`dropdown-container ${suggestions.length != 0 ? "height-auto" : "dropdown-container-height"}`}>
          <div className='search-box'>
            <input 
            {...inputsearchProps}
            ref={inputRef}
            onClick={onInputClick} />

            <i
              className='uil uil-search'
              onClick={() => {
                if (value) {
                  // saveToSearchHistory(value);
                  history.push(`/search?type=text&key=${value}`);
                }
              }}
            ></i>
          </div>


          {suggestions.length == 0 ? (
            <>
              <div className="dropdown-section">
                <p>
                  <i className="uil uil-fire" style={{ marginRight: "8px", color: "orange" }}></i>
                  Trending</p>
                <ul>
                  {trendWords.map((word, index) => (
                    <li
                      key={`trend-${index}`}
                      onClick={() => {
                        setValue(word);
                        // saveToSearchHistory(word);
                        setDropdownVisible(false);
                        history.push(`/search?type=text&key=${word}`);
                      }}
                    >
                      {word}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="dropdown-section">
                <p>
                  <i className="uil uil-history" style={{ marginRight: "8px", color: "#555" }}></i>
                  Recently Searched by You </p>
                <ul>
                  {userSearchHistory.map((word, index) => (
                    <li
                      key={`history-${index}`}
                      onClick={() => {
                        setValue(word);
                        setDropdownVisible(false);
                        history.push(`/search?type=text&key=${word}`);
                      }}
                    >
                      {word}
                    </li>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <>
            <div className="suggestion-section">
            {/* <p className="bold">
              <i
                className="uil uil-box"
                style={{ marginRight: "8px", color: "blue" }}
              ></i>
              Keywords
            </p> */}
            <ul>
              {suggestions.keywords.map((suggestion, index) => (
                <li
                  key={`suggestion-${index}`}
                  onClick={() => {
                    setValue(suggestion.search_word);
                    setDropdownVisible(false);
                    history.push(`/search?type=text&key=${suggestion.search_word}`);
                  }}
                >
                  {  renderSuggestion(suggestion.search_word)}
                </li>
              ))}
            </ul>
          </div>
            </>
          )}
        </div>
      </>
    );
  };

  //  ==================== 
  const inputProps = {
    placeholder: "Search for products..",
    value,
    type: "text",
    className: "prompt srch10",
    onChange: onChange,
    onKeyDown: onKeyDown,
  };


  const renderInputComponent = (inputProps) => (
    <div className='ui left icon input swdh10'>
      <input {...inputProps} onClick={onInputClick} />

      <i
        className='uil uil-search-alt icon icon1 pointer searchIcon'
        onClick={() => {
          if (value) {
            // saveToSearchHistory(value);
            history.push(`/search?type=text&key=${value}`);
          }
        }}
      ></i>
    </div>
  );

  

  return (
    // <div className='search120'>
    <div className={className}>
      <div className='ui search'>
        {renderInputComponent(inputProps)}
     
        {renderDropdown()}
      </div>
    </div>
  );
};

export default HeaderSearch;
